/* tslint:disable:forbid-import */
import { orchestratorAction } from 'satcheljs';
/* tslint:enable:forbid-import */
import { selectCategory as selectCategoryOrchestrator } from 'owa-options-store';
import confirmDirtyOptionsAndPerformAction from './confirmDirtyOptionsAndPerformAction';
export default orchestratorAction('selectCategory', function selectCategory(category) {
    var continueAfterConfirmCallback = function () {
        selectCategoryOrchestrator(category);
    };
    confirmDirtyOptionsAndPerformAction(continueAfterConfirmCallback);
});
//# sourceMappingURL=selectCategory.js.map